/**
 * The one close button every panel, dialog and popover uses: a 28 px icon
 * button with the shared × glyph, an accessible name AND a `data-tip` hover
 * label. Replaces the four hand-rolled "×"/"✕" text buttons that each had
 * their own class and no hover label.
 */
import { iconClose } from "./icons.js";

export interface CloseButtonProps {
  onClick: () => void;
  /** Accessible name and hover label. Default "Close". */
  label?: string;
  className?: string;
}

export function CloseButton({ onClick, label = "Close", className }: CloseButtonProps) {
  return (
    <button
      type="button"
      className={`icon-btn icon-btn-close${className === undefined ? "" : ` ${className}`}`}
      onClick={onClick}
      aria-label={label}
      data-tip={label}
    >
      {iconClose}
    </button>
  );
}
